"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailedRecord = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class FailedRecord extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.details = "";
    }
    schema() {
        return FailedRecord.schema;
    }
    subject() {
        return FailedRecord.subject;
    }
}
exports.FailedRecord = FailedRecord;
FailedRecord.subject = "failed-record";
FailedRecord.schema = {
    "type": "record",
    "name": "FailedRecord",
    "namespace": "storyblocks.common",
    "fields": [
        {
            "name": "meta",
            "type": {
                "type": "record",
                "name": "Meta",
                "fields": [
                    {
                        "name": "uuid",
                        "type": "string"
                    },
                    {
                        "name": "emitted",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "origin",
                        "type": {
                            "type": "enum",
                            "name": "Origin",
                            "symbols": [
                                "ACCOUNT_SERVICE",
                                "AFTER_EFFECTS_PLUGIN",
                                "AUDIOBLOCKS",
                                "BILLING_SERVICE",
                                "CONTENT_JOB",
                                "CONTENT_RATING_APP",
                                "CONTENT_SERVICE",
                                "CONTRIBUTOR_PORTAL",
                                "DATA_JOB",
                                "EXAMPLE_SERVICE",
                                "FEATURE_FLAG_SERVICE",
                                "GRAPHICSTOCK",
                                "MISC",
                                "OUTDATED_SCHEMA",
                                "PAYOUT_SERVICE",
                                "PREMIERE_PRO_PLUGIN",
                                "SEARCH_SERVICE",
                                "STORYBLOCKS",
                                "STORYBLOCKS_NEXTJS",
                                "STORYBOARD",
                                "SUBSCRIPTION_SERVICE",
                                "TEMPLATE_EDITOR",
                                "TRANSLATION_SERVICE",
                                "USER_SERVICE",
                                "VIDEOBLOCKS",
                                "WEBHOOKS_GATEWAY"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "trace",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "TraceContext",
                                "fields": [
                                    {
                                        "name": "traceId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "pageTraceId",
                                        "type": "string",
                                        "default": ""
                                    },
                                    {
                                        "name": "spanId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "parentId",
                                        "type": "string",
                                        "default": ""
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "payload",
            "type": "string"
        },
        {
            "name": "topic",
            "type": "string"
        },
        {
            "name": "details",
            "type": "string",
            "default": ""
        }
    ]
};
//# sourceMappingURL=FailedRecord.js.map